module.exports = __webpack_public_path__ + "static/media/apecoin.be5272d8.png";